import { useEffect } from "react"
import { useClearStalePendingAgentAutoSend } from "@/hooks/use-clear-stale-pending-agent-auto-send"
import { useUiStore, type AgentHandoffSurface } from "@/stores/ui-store"

const pageMountCounts = new Map<string, number>()

export function usePendingAgentAutoSend(surface: AgentHandoffSurface, projectId: number) {
  const pending = useUiStore((s) => s.pendingAgentAutoSend)
  const clearPendingAgentAutoSend = useUiStore((s) => s.clearPendingAgentAutoSend)
  useClearStalePendingAgentAutoSend(projectId)

  const match = pending?.surface === surface && pending.projectId === projectId ? pending : null

  useEffect(() => {
    const key = `${surface}:${projectId}`
    pageMountCounts.set(key, (pageMountCounts.get(key) ?? 0) + 1)
    return () => {
      pageMountCounts.set(key, (pageMountCounts.get(key) ?? 1) - 1)
      queueMicrotask(() => {
        if ((pageMountCounts.get(key) ?? 0) > 0) return
        const current = useUiStore.getState().pendingAgentAutoSend
        if (current?.surface === surface && current.projectId === projectId) {
          useUiStore.getState().clearPendingAgentAutoSend()
        }
      })
    }
  }, [surface, projectId])

  return {
    message: match?.message ?? null,
    selectedEntityId: match?.selectedEntityId ?? null,
    selectedShotId: match?.selectedShotId ?? null,
    clear: clearPendingAgentAutoSend,
  }
}
